var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "move-wrap" }, [
    _c("div", { ref: "hitline", staticClass: "hitline" }),
    _c(
      "ul",
      { ref: "scroll", staticClass: "move-box" },
      _vm._l(_vm.virtual_case_awards, function (item, index) {
        return _c(
          "li",
          {
            key: index + "-" + Math.random(),
            staticClass: "move-item",
            class: [{ active: index == 37 }, { hide: index != 37 }],
          },
          [
            index == 37
              ? _c(
                  "div",
                  { ref: "win_item", refInFor: true, staticClass: "item-box" },
                  [
                    _c("img", {
                      staticClass: "gun-icon",
                      attrs: { src: _vm._f("imgfilter")(item.itempic) },
                    }),
                    _c("div", { staticClass: "price" }, [
                      _vm._v("+ " + _vm._s(item.price)),
                    ]),
                  ]
                )
              : _c("div", { staticClass: "item-box" }, [
                  _c("img", {
                    staticClass: "gun-icon",
                    attrs: { src: _vm._f("imgfilter")(item.itempic) },
                  }),
                ]),
            _c("c-svg", {
              staticClass: "itembg",
              class: "rarity" + item.rarity,
              attrs: { src: "itembg.svg" },
            }),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }